__webpack_require__.p = "/privacy-policy/";